// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2XJmq","error":"Textarea_error__ou-74","readonly":"Textarea_readonly__2gCGF","disabled":"Textarea_disabled__3Om0B"};